import { render } from "./BaselinesIcon.vue?vue&type=template&id=49e47871"
import script from "./BaselinesIcon.vue?vue&type=script&lang=js"
export * from "./BaselinesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__